/**
 * Generated bundle index. Do not edit.
 */

export {CoreModule} from './public_api';

export {NavComponent as ɵa} from './src/app/core/nav/nav.component';